exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rtabs[data-v-d2e3df70]{background:#fff;border:1px solid #e8ebef;height:100%}.rtabs .rpanel-content[data-v-d2e3df70]{height:calc(100% - 43px)}.rtabs .rtabs-list[data-v-d2e3df70]{border-bottom:1px solid #e8ebef;line-height:42px;height:43px;padding:0 24px}.rtabs .rtabs-list .rtab[data-v-d2e3df70]{float:left;margin-right:24px;box-sizing:border-box;list-style:none;text-align:center;cursor:pointer}.rtabs .rtabs-list .t-name[data-v-d2e3df70]{font-size:14px;color:#282e3d}.rtabs .rtabs-list .active[data-v-d2e3df70]{display:block;width:100%;color:#2c7df1;border-bottom:2px solid #2c7df1}", ""]);

// exports
